import React from 'react'
import Link from 'gatsby-link'

import styled from 'styled-components';
import Album from '../components/album';

const AlbumsWarpper = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 4rem;
  align-items: center;
  padding: 0;
  margin: 0;
  padding: 0 4rem;

  @media(max-width: 500px) {
    grid-gap: 2rem;
    padding: 0 2rem;
  }
`

const IndexPage = ({data}) => (
  <div style={{flex: "1"}}>
    <AlbumsWarpper>
    	{data.allMarkdownRemark.edges.map(o => (
			<Album node={o.node}/>
      ))}
    </AlbumsWarpper>
  </div>
)

const MusicLink = ({children, url}) => {
  if(url.trim() === "") {
    return (
      <a style={{textDecoration: 'line-through', color: 'black', opacity: '0.5'}}>{children}</a>
    )
  }
  return (
    <a target="_blank" href={url} rel="noopener noreferrer">{children}</a>
  )
}
export default IndexPage

export const query = graphql`
query indexQuery {
  allMarkdownRemark(
    limit: 2000
    sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: {public: {eq: "true" }}
      }
  ) {
    edges {
      node {
        id
        frontmatter {
          title
          date
          itunesUrl
          applemusUrl
          spotifyUrl
          googleUrl
          tidalUrl
          soundcloudUrl
          public
          comingSoon
          path
          img {
            childImageSharp {
              resolutions(width: 800, height: 800) {
                src
              }
            }
          }
        }
      }
    }
  } 
}
`



// WEBPACK FOOTER //
// ./src/pages/index.js